import NewReleases from "@mui/icons-material/NewReleases";
import { Button } from "@mui/material";
import type { FC } from "react";

export const WhatsNew: FC = () => {
  return (
    <Button
      size="small"
      sx={{ color: "text.sidebar", p: 0 }}
      data-analytics-id="sidebar-whats-new"
      variant="text"
      startIcon={<NewReleases />}
      href="https://help.changeengine.com/articles/2026-product-updates-yeFMukDi6a"
      target="_blank"
    >
      What’s new?
    </Button>
  );
};
